<!--Оплати-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="104"
  height="18"
  viewBox="0 0 104 18"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 3.5H14V0.5H3V3.5Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 17.5H14V14.5H3V17.5Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0 14.5H3V3.5H0V14.5Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 14.5H17V3.5H14V14.5Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M40 14.5H42.75V5.92257H48.25V14.5H51V3.5H40V14.5Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M79 5.92476H83.5514V14.5H86.4486V5.92476H91V3.5H79V5.92476Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M54.6913 11.75H53V14.5H53.8927C56.0524 14.5 57.2907 13.2851 57.2907 11.1671V5.92257H62.196V14.5H65V3.5H54.6913V11.75Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M95.0293 11.2367H94.8905V3.5H92V14.5H95.8852L100.972 6.76354H101.109V14.5H104V3.5H100.116L95.0293 11.2367Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M71 9.5L72.8985 5.5H73.1018L75 9.5H71ZM71.1316 3.5L66 14.5H68.9769L69.9549 12.3556H76.0454L77.0236 14.5H80L74.8684 3.5H71.1316Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M30.5 12.5C28.1494 12.5 27 11.0913 27 9C27 6.90035 28.1781 5.5 30.5 5.5C32.8248 5.5 34 6.90035 34 9C34 11.1075 32.8679 12.5 30.5 12.5ZM30.5 2.5C26.5038 2.5 24 4.75009 24 8.5C24 12.2814 26.5343 14.5 30.5 14.5C34.6197 14.5 37 12.1223 37 8.5C37 4.92528 34.6197 2.5 30.5 2.5Z"
    fill="#7C7E92"
  />
</svg>

<!--Visa-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="49"
  height="18"
  viewBox="0 0 49 18"
  fill="none"
>
  <path
    d="M18 1.5L11.7753 15.5H7.73128L4.67841 4.33733C4.63877 4.076 4.55947 3.81467 4.40088 3.59067C4.24229 3.36667 4.00441 3.21733 3.76652 3.10533C2.57709 2.54533 1.30837 2.172 0 1.91067L0.0792953 1.5H6.62115C7.05727 1.5 7.45374 1.64933 7.77093 1.91067C8.08811 2.172 8.32599 2.54533 8.36564 2.91867L9.99119 11.02L13.9956 1.5H18Z"
    fill="#7C7E92"
  />
  <path d="M24 1.5L20.8362 15.5H17L20.1638 1.5H24Z" fill="#7C7E92" />
  <path
    d="M28.7551 5.79124C28.7143 7.53093 34.2653 7.72423 34.2653 11.5515C34.2653 14.5283 31.5714 16.5 27.4082 16.5C25.898 16.5 24.3878 16.2294 23 15.7268L23.7347 12.5567C24.9592 13.1753 26.3469 13.4845 27.7755 13.4459C28.9184 13.4459 30.1429 13.0206 30.1429 12.0541C30.1837 11.3969 29.5714 10.933 28.102 10.2371C26.5918 9.54124 24.6327 8.38144 24.6327 6.29381C24.6735 3.47165 27.4082 1.5 31.3265 1.5C32.5918 1.5 33.8163 1.73196 35 2.15722L34.3061 5.21134C33.0816 4.6701 31.7347 4.43814 30.4286 4.55412C29.2449 4.70876 28.7551 5.25 28.7551 5.79124Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M44.8127 1.5L48 15.5H44.4092L43.9251 13.4093H38.9222L38.1153 15.5H34L39.8098 2.508C39.9712 2.20933 40.1729 1.948 40.4957 1.76133C40.7781 1.612 41.1412 1.5 41.5043 1.5H44.8127ZM43.2392 10.5347L42.0692 5.27067L40.0115 10.5347H43.2392Z"
    fill="#7C7E92"
  />
</svg>

<!--MasterCard-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="26"
  viewBox="0 0 40 26"
  fill="none"
>
  <path d="M25 21.5H15V3.5H25V21.5Z" fill="#7C7E92" />
  <path
    d="M16.7228 18.0482C17.5031 19.6162 18.6345 20.9547 20 22.0638C18.2834 23.4024 16.2156 24.2055 13.9918 24.435C11.807 24.6644 9.58316 24.282 7.63244 23.3641C5.64271 22.408 3.96509 20.9165 2.79466 19.119C1.62423 17.2833 1 15.1417 1 13C1 10.8583 1.62423 8.71667 2.79466 6.88096C3.96509 5.0835 5.64271 3.59198 7.63244 2.63588C9.58316 1.71803 11.807 1.33559 13.9918 1.56505C16.2156 1.79451 18.2834 2.59764 20 3.93618C18.6345 5.04525 17.5031 6.38379 16.7228 7.95179C15.9425 9.5198 15.5133 11.2408 15.5133 13C15.5133 14.7592 15.9425 16.4802 16.7228 18.0482Z"
    fill="#7C7E92"
  />
  <path
    d="M39 13C39 15.1417 38.377 17.2833 37.209 19.119C36.041 20.9547 34.3668 22.408 32.3811 23.3641C30.3955 24.282 28.1762 24.6644 25.9959 24.435C23.8156 24.2055 21.752 23.4024 20 22.0638C21.4016 20.993 22.5307 19.6162 23.3094 18.0482C24.0881 16.4802 24.4775 14.7592 24.4775 13C24.4775 11.2408 24.0881 9.5198 23.3094 7.95179C22.5307 6.38379 21.4016 5.04525 20 3.93618C21.752 2.59764 23.8156 1.79451 25.9959 1.56505C28.1762 1.33559 30.3955 1.71803 32.3811 2.63588C34.3668 3.59198 36.041 5.04525 37.209 6.88096C38.377 8.71667 39 10.8583 39 13Z"
    fill="#BDBEC8"
  />
</svg>

<!--MasterCard-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="37"
  height="40"
  viewBox="0 0 37 40"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 35.9416C5 37.1241 4.17525 38 3.02061 38C1.90721 38 1 37.2117 1 35.7226V34.9781C1 33.5328 1.6598 32.4818 2.89691 32.2628L4.6701 32V32.7883L3.06185 32.9635C2.31959 33.1387 1.86598 33.6642 1.82474 34.6715C2.1134 34.1022 2.64949 33.927 3.14433 33.927C4.2165 33.927 5 34.7591 5 35.9416ZM4.17526 35.9416C4.17526 35.1971 3.68041 34.6715 3.02061 34.6715C2.31958 34.6715 1.82474 35.1971 1.82474 35.9416C1.82474 36.6423 2.31958 37.1679 3.02061 37.1679C3.68041 37.1679 4.17526 36.6423 4.17526 35.9416Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.88421 36.268C6.92632 36.8866 7.43158 37.299 8.06316 37.299C8.52631 37.299 8.86316 37.0928 9.03158 36.8454H9.87369C9.62106 37.5052 8.94737 38 8.06316 38C6.88421 38 6 37.2165 6 36.0206C6 34.866 6.84211 34 7.97895 34C9.07369 34 9.87368 34.701 10 35.9381C10 36.0481 10 36.1581 10 36.268H6.88421ZM9.11579 35.6495C9.11579 35.0722 8.65264 34.701 8.02106 34.701C7.38948 34.701 6.92632 35.0722 6.88421 35.6495H9.11579Z"
    fill="#7C7E92"
  />
  <path
    d="M11 37.2238C11.3182 37.2238 11.6818 37.0519 11.6818 36.4071V34H15V37.9975H14.0455V34.7737H12.5455V36.4071C12.5455 37.5247 11.8636 38.0405 11 37.9975V37.2238Z"
    fill="#7C7E92"
  />
  <path
    d="M16.8313 35.8495L18.9518 34H17.8434L16.6386 35.0323L15.9639 35.5914V34H15.0482H15V38H15.0482H15.9639V36.1075L16.6386 36.7957L17.8434 38H19L16.8313 35.8495Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M24 34.0825V37.9175H22.9706V37.3402C22.5784 37.7526 21.8922 38 21.3039 38C21.3039 38 21.2876 38 21.2549 38C20.5686 38 20.0294 37.7938 19.6863 37.4639C19.6536 37.4364 19.6373 37.4227 19.6373 37.4227C19.6046 37.3952 19.5882 37.3814 19.5882 37.3814C19.1961 36.9966 19 36.543 19 36.0206C19 36.0206 19 36.0069 19 35.9794C19 35.4433 19.1961 34.9485 19.5882 34.6186C19.5882 34.5911 19.6046 34.5773 19.6373 34.5773C19.6373 34.5773 19.6536 34.5636 19.6863 34.5361C20.0294 34.2062 20.5686 34 21.2549 34C21.2876 34 21.3039 34 21.3039 34C21.8922 34 22.5784 34.2474 22.9706 34.6598L23.0686 34.0825H24ZM23.0196 35.9794C23.0196 35.3196 22.3824 34.7835 21.549 34.7835C20.6667 34.7835 20.0784 35.2784 20.0784 35.9794C20.0784 36.7216 20.6667 37.2165 21.549 37.2165C22.3824 37.2165 23.0196 36.6804 23.0196 35.9794Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M24.8823 34.0876L25.0294 34.7007C25.4216 34.2628 26.0588 34 26.6961 34C26.7288 34 26.7451 34 26.7451 34C27.3824 34 27.9216 34.219 28.3137 34.5693C28.3464 34.5985 28.3628 34.6131 28.3628 34.6131C28.3628 34.6131 28.3791 34.6277 28.4118 34.6569C28.7549 35.0073 29 35.5328 29 36.1022C29 36.1314 29 36.146 29 36.146C29 36.7153 28.7549 37.1971 28.4118 37.5912C28.3791 37.5912 28.3628 37.6058 28.3628 37.635C28.3628 37.635 28.3464 37.6496 28.3137 37.6788C27.9216 38.0292 27.3824 38.2482 26.7451 38.2482C26.7451 38.2482 26.7288 38.2482 26.6961 38.2482C26.0588 38.2482 25.4216 37.9854 25.0294 37.5474V40H24V34.0876H24.8823ZM26.451 37.4161C27.3333 37.4161 27.9706 36.8905 27.9706 36.1022C27.9706 35.3577 27.3333 34.8321 26.451 34.8321C25.6176 34.8321 25.0294 35.4015 25.0294 36.1022C25.0294 36.8467 25.6176 37.4161 26.451 37.4161Z"
    fill="#7C7E92"
  />
  <path
    d="M36 35.5579V38H35.021V35.7684C35.021 35.0526 34.5804 34.7579 33.993 34.7579C33.4546 34.7579 33.014 35.0947 33.014 35.7684V38H31.986V35.7684C31.986 35.0526 31.5454 34.7579 31.007 34.7579C30.4196 34.7579 29.979 35.0947 29.979 35.7684V38H29V34.0842H29.8811L29.979 34.6316C30.2238 34.2526 30.6643 34 31.3496 34C31.986 34 32.4755 34.2105 32.7203 34.6316C33.0629 34.2526 33.5524 34 34.2867 34C35.3147 34 36 34.5895 36 35.5579Z"
    fill="#7C7E92"
  />
  <path
    d="M16.8097 22.6958L12.276 27.4239C11.9488 27.7195 11.9488 28.1135 12.089 28.409C12.1825 28.6552 12.4629 28.9507 12.8836 28.9507L20.8761 29C21.4837 29 21.9978 28.4582 21.9978 27.818C21.9978 27.7851 21.9978 27.7523 21.9978 27.7195C22.0445 25.8971 21.3434 24.0748 20.0815 22.745C19.1934 21.76 17.7445 21.76 16.8097 22.6958Z"
    fill="#7C7E92"
  />
  <path
    d="M11.7992 20.0996L5.81311 20C5.41697 20 5.15287 20.2988 5.06484 20.5976C4.97681 20.8467 4.93281 21.2451 5.24091 21.5937L10.5668 27.62C10.9629 28.118 11.6232 28.118 12.0633 27.6698C12.0633 27.6366 12.078 27.6034 12.1073 27.5702C13.2957 26.2753 13.956 24.4325 14 22.5898C14 21.1953 13.0317 20.0996 11.7992 20.0996Z"
    fill="#7C7E92"
  />
  <path
    d="M6.01317 18.9978C6.04132 18.9978 6.06947 18.9978 6.09761 18.9978C7.65959 19.0445 9.22156 18.3434 10.3614 17.0815C11.2057 16.1934 11.2057 14.7445 10.4036 13.8097L6.35089 9.27596C6.0976 8.94879 5.75987 8.94879 5.50658 9.089C5.2955 9.18248 5.04222 9.46292 5.04222 9.88358L5 17.8761C5 18.4837 5.46437 18.9978 6.01317 18.9978Z"
    fill="#7C7E92"
  />
  <path
    d="M7.37608 8.89704C8.50912 10.2175 10.1215 10.9511 11.7339 11C12.9541 11 13.9129 9.92406 13.9129 8.55469L14 1.90346C14 1.4633 13.7385 1.16986 13.4771 1.07205C13.2592 0.974239 12.9105 0.925333 12.6055 1.26768L7.3325 7.18532C6.89672 7.62548 6.89672 8.35907 7.28892 8.84813C7.31797 8.84813 7.34703 8.86443 7.37608 8.89704Z"
    fill="#7C7E92"
  />
  <path
    d="M20.1903 7.3042L24.724 2.57605C25.0512 2.28054 25.0512 1.88653 24.911 1.59102C24.8175 1.34476 24.5371 1.04925 24.1164 1.04925L16.1239 1C15.5163 1 15.0022 1.54177 15.0022 2.18204C15.0022 2.21487 15.0022 2.24771 15.0022 2.28054C14.9555 4.10285 15.6566 5.92516 16.9185 7.25495C17.8066 8.23998 19.2555 8.23998 20.1903 7.3042Z"
    fill="#7C7E92"
  />
  <path
    d="M25.2008 10.9004L31.1869 11C31.583 11 31.8471 10.7012 31.9352 10.4024C32.0232 10.1533 32.0672 9.7549 31.7591 9.40627L26.4332 3.38C26.0371 2.88196 25.3768 2.88196 24.9367 3.3302C24.9367 3.3634 24.922 3.3966 24.8927 3.4298C23.7043 4.72471 23.044 6.56745 23 8.4102C23 9.80471 23.9683 10.9004 25.2008 10.9004Z"
    fill="#7C7E92"
  />
  <path
    d="M30.9868 11.0022C30.9587 11.0022 30.9305 11.0022 30.9024 11.0022C29.3404 10.9555 27.7784 11.6566 26.6386 12.9185C25.7943 13.8066 25.7943 15.2555 26.5964 16.1903L30.6491 20.724C30.9024 21.0512 31.2401 21.0512 31.4934 20.911C31.7045 20.8175 31.9578 20.5371 31.9578 20.1164L32 12.1239C32 11.5163 31.5356 11.0022 30.9868 11.0022Z"
    fill="#7C7E92"
  />
  <path
    d="M29.6239 21.103C28.4909 19.7825 26.8785 19.0489 25.2661 19C24.0459 19 23.0871 20.0759 23.0871 21.4453L23 28.0965C23 28.5367 23.2615 28.8301 23.5229 28.9279C23.7408 29.0258 24.0895 29.0747 24.3945 28.7323L29.6675 22.8147C30.1033 22.3745 30.1033 21.6409 29.7111 21.1519C29.682 21.1519 29.653 21.1356 29.6239 21.103Z"
    fill="#7C7E92"
  />
</svg>

<!--bepaid-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="61"
  height="18"
  viewBox="0 0 61 18"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.5973 14.5C13.5796 14.5 11 11.8752 11 8.37543L15.5266 3.51465C19.3717 3.27162 22 6.09086 22 9.05593C22 9.54201 21.9513 10.0119 21.854 10.4656H14.1151C14.6018 11.2919 15.4779 11.8752 16.5487 11.8752H20.5885V14.5H16.5973ZM14.1637 7.69492H19.0797C18.5929 6.81998 17.6681 6.23669 16.5973 6.23669C15.5265 6.23669 14.6018 6.81998 14.1637 7.69492Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.76232 4.64286C3.2556 4.26191 4.34082 3.83333 5.52467 3.83333C8.53364 3.83333 11 6.21429 11 9.16667C11 12.119 8.53364 14.5 5.52467 14.5C2.46638 14.5 0 12.119 0 9.16667V1.5H2.76232V4.64286ZM8.33634 9.16667C8.33634 7.64286 7.05382 6.40476 5.52467 6.40476C3.9462 6.40476 2.66369 7.64286 2.66369 9.16667C2.66369 10.6905 3.9462 11.881 5.52467 11.881C7.05382 11.881 8.33634 10.6905 8.33634 9.16667Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M61 1.5V10.7381L56.4125 14.5C52.2691 14.5 50 12.119 50 9.16667C50 6.21429 52.4664 3.83333 55.5247 3.83333C56.6592 3.83333 57.7444 4.26191 58.2377 4.64286V1.5H61ZM58.3363 9.16667C58.3363 7.64286 57.1032 6.40476 55.5247 6.40476C53.9462 6.40476 52.6637 7.64286 52.6637 9.16667C52.6637 10.6905 53.9462 11.9286 55.5247 11.9286C57.1032 11.9286 58.3363 10.6905 58.3363 9.16667Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M25.7991 16.5H23.0491L23 9.02381V8.78571C23 5.88095 25.4554 3.5 28.5 3.5C31.5446 3.5 34 5.88095 34 8.78571C34 11.7381 31.5446 14.119 28.5 14.119C27.3705 14.119 26.2902 13.6905 25.7991 13.3095V16.5ZM31.2991 8.83333C31.2991 7.30952 30.0714 6.07143 28.5 6.07143C26.9286 6.07143 25.6518 7.30952 25.6518 8.83333C25.6518 10.3571 26.9286 11.5952 28.5 11.5952C30.0714 11.5952 31.2991 10.3571 31.2991 8.83333Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M42.2257 11.7863L39.5 14.5C36.4823 14.5 34 12.0286 34 9.02423C34 5.97137 36.4823 3.5 39.5 3.5C42.5664 3.5 45 5.97137 45 9.02423V14.3546H42.2257V11.7863ZM42.3717 9.07269C42.3717 7.47357 41.1062 6.21366 39.5 6.21366C37.9425 6.21366 36.677 7.47357 36.677 9.07269C36.677 10.6233 37.9425 11.8833 39.5 11.8833C41.1062 11.8833 42.3717 10.6233 42.3717 9.07269Z"
    fill="#7C7E92"
  />
  <path d="M46 6.5H49V14.5H46V6.5Z" fill="#7C7E92" />
  <path d="M46 1.5H49V4.5H46V1.5Z" fill="#7C7E92" />
</svg>

<!--samsung pay-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="56"
  height="24"
  viewBox="0 0 56 24"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M36.3586 14H38L33.9448 24H32.3517L33.8 20.5049L31 14H32.6897L34.5724 18.6117L36.3586 14Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M27.3108 14C28.2095 14 28.9662 14.381 29.4392 14.9524V14.1429H31V20.8571H29.4392V20C28.9662 20.619 28.1622 21 27.3108 21C25.7027 21 24 19.7143 24 17.5238C24 15.2857 25.6554 14 27.3108 14ZM27.5473 15.4286C26.4122 15.4286 25.5135 16.3333 25.5135 17.4762C25.5135 18.6667 26.4122 19.5714 27.5473 19.5714C28.6825 19.5714 29.5338 18.6667 29.5338 17.4762C29.5338 16.3333 28.6825 15.4286 27.5473 15.4286Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.9032 13C22.6935 13 24 14.2727 24 15.8636C24 17.4545 22.6935 18.7273 20.9032 18.7273H19.5968V21H18V13H20.9032ZM20.8065 14.3636H19.5968V17.3182H20.8065C21.7258 17.3182 22.3548 16.6818 22.3548 15.8636C22.3548 15.0455 21.7258 14.3636 20.8065 14.3636Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M55 3.53488V5.62791C55 5.76744 54.9573 5.86047 54.9573 6.09302C54.8291 7.48837 53.7179 8 52.4786 8C51.2393 8 50.1282 7.48837 50 6.09302C50 5.86047 50 5.76744 50 5.62791V2.37209C50 2.23256 50 2 50 1.90698C50.1709 0.465116 51.2393 0 52.4786 0C53.7179 0 54.8291 0.465116 54.9573 1.90698C54.9573 2.13953 54.9573 2.37209 54.9573 2.37209V2.65116H53.2051V2.23256C53.2051 2.23256 53.2052 2.04651 53.1624 1.90698C53.1624 1.76744 52.9914 1.34884 52.4786 1.34884C51.9658 1.34884 51.7949 1.72093 51.7949 1.90698C51.7521 2 51.7521 2.13954 51.7521 2.27907V5.76744C51.7521 5.86047 51.7521 6 51.7521 6.09302C51.7949 6.27907 51.9658 6.65116 52.4786 6.65116C52.9914 6.65116 53.1624 6.27907 53.2051 6.09302C53.2051 6 53.2051 5.89147 53.2051 5.76744V4.65116H52.4786V3.53488H55Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M45.2174 0H47V8H44.4348L42.6956 1.47239H42.6522L42.7391 8H41V0H43.6522L45.2609 6.33129H45.3043L45.2174 0Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M38 5.55294C38 5.69412 37.9569 5.97647 37.9569 6.07059C37.8276 7.52941 36.7931 8 35.5 8C34.2069 8 33.1724 7.52941 33.0431 6.07059C33 5.97647 33 5.69412 33 5.55294V0H34.8104V5.74118C34.8104 5.83529 34.8104 5.97647 34.8104 6.02353C34.8535 6.21176 35.0259 6.58824 35.5 6.58824C35.9742 6.58824 36.1466 6.21176 36.1897 6.02353C36.1897 5.97647 36.1897 5.83529 36.1897 5.74118V0H38V5.55294Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M31.9414 5.10345C31.9921 5.24138 32.0429 5.65517 31.9414 6.29885C31.7382 7.54023 30.5195 8 28.9961 8C27.4727 8 26 7.49425 26 5.83908V5.28736H28.2344V5.97701C28.2344 6.3908 28.5391 6.66667 29.0469 6.66667C29.6055 6.66667 29.8086 6.43678 29.8594 6.16092C29.9101 6.02299 29.9609 5.7931 29.8594 5.6092C29.4531 4.64368 26.5078 4.18391 26.1524 2.66667C26.0508 2.29885 26.0508 1.97701 26.1015 1.65517C26.3554 0.45977 27.5234 0 28.9961 0C30.1641 0 31.7891 0.275862 31.7891 1.88506V2.3908H29.707V1.93103C29.707 1.56322 29.4531 1.28736 28.9453 1.28736C28.4375 1.28736 28.2852 1.51724 28.1836 1.7931C28.1836 1.83908 28.1836 2.02299 28.2344 2.16092C28.4375 3.03448 31.5859 3.49425 31.9414 5.10345Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M24.8524 0L25 8H22.9836L22.9345 0.824242H22.8852L21.5574 8H19.4918L18.1148 0.824242H18.0656L18.0164 8H16L16.1967 0H19.4918L20.4754 6.10909H20.5246L21.5082 0H24.8524Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0149 8H8L9.38805 0H12.6567L14 8H12.0298L11.0448 0.775757H11L10.0149 8Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1 5.86364V5.27273H3.22056V6C3.22056 6.40909 3.52334 6.68182 4.07848 6.68182C4.63362 6.68182 4.78501 6.40909 4.88594 6.18182C4.88594 6.04545 4.93642 5.77273 4.83549 5.59091C4.43175 4.63636 1.45418 4.18182 1.10091 2.68182C1.05044 2.27273 1.05044 2 1.10091 1.68182C1.30278 0.454545 2.51402 0 3.97757 0C5.18878 0 6.80371 0.272727 6.80371 1.90909V2.40909H4.73458V1.95455C4.73458 1.54545 4.43177 1.27273 3.97757 1.27273C3.42243 1.27273 3.27104 1.54545 3.17011 1.77273C3.17011 1.86364 3.1701 2 3.22056 2.18182C3.42243 3.04545 6.60187 3.5 6.95514 5.09091C6.95514 5.22727 7.05607 5.63636 6.95514 6.31818C6.75327 7.54545 5.49157 8 4.02802 8C2.46355 8 1 7.5 1 5.86364Z"
    fill="#7C7E92"
  />
</svg>

<!--g pay-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="50"
  height="26"
  viewBox="0 0 50 26"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.0118 1H36.9881C43.635 1 49 6.40712 49 13C49 19.6403 43.635 25 36.9881 25H13.0118C6.41243 25 1 19.6403 1 13C1 6.40712 6.41243 1 13.0118 1Z"
    fill="#7C7E92"
    stroke="#949EAC"
    stroke-width="0.559686"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M24.2602 13.4672V17.2201H23V8H26.2959C27.136 8 27.8469 8.26255 28.4286 8.78765C29.0102 9.31274 29.301 9.96139 29.301 10.7336C29.301 11.5058 29.0102 12.1544 28.4286 12.6795C27.8469 13.2046 27.136 13.4672 26.2959 13.4672H24.2602ZM24.2602 9.11197V12.3552H26.3443C26.829 12.3552 27.233 12.1853 27.5561 11.8456C27.8792 11.5367 28.0408 11.166 28.0408 10.7336C28.0408 10.3012 27.8792 9.9305 27.5561 9.62162C27.233 9.28185 26.829 9.11197 26.3443 9.11197H24.2602ZM32.2092 10.6873C33.114 10.6873 33.841 10.9189 34.3903 11.3822C34.9073 11.8456 35.1658 12.4942 35.1658 13.3282V17.2201H33.9541V16.3398H33.9056C33.3886 17.0502 32.71 17.4054 31.8699 17.4054C31.1267 17.4054 30.5128 17.2046 30.0281 16.8031C29.5434 16.4015 29.301 15.8919 29.301 15.2741C29.301 14.5946 29.5595 14.0695 30.0765 13.6988C30.5935 13.2973 31.2882 13.0965 32.1607 13.0965C32.9039 13.0965 33.5017 13.2355 33.9541 13.5135V13.2355C33.9541 12.834 33.7925 12.4788 33.4694 12.1699C33.1301 11.8919 32.6939 11.7529 32.2577 11.7529C31.5791 11.7529 31.0297 12.0309 30.6097 12.5869L29.4949 11.9382C30.1088 11.1042 31.0136 10.6873 32.2092 10.6873ZM30.5612 15.2741C30.5612 15.583 30.7066 15.8456 30.9975 16.0618C31.256 16.278 31.5791 16.3861 31.9668 16.3861C32.4839 16.3861 32.9523 16.2008 33.3724 15.8301C33.7602 15.4595 33.9541 15.0116 33.9541 14.4865C33.5663 14.2085 33.0331 14.0695 32.3546 14.0695C31.8376 14.0695 31.4175 14.1931 31.0944 14.4402C30.7389 14.6564 30.5612 14.9344 30.5612 15.2741ZM42 10.9189L37.8316 20H36.5714L38.074 16.8031L35.3597 10.9189H36.7168L38.7041 15.4595L40.6428 10.9189H42Z"
    fill="#F6F6F9"
  />
  <path
    d="M17.4545 17H15.7727V15.6449C16.3182 15.271 16.6818 14.7103 16.8182 14.0561H14V12H18.9091C18.9697 12.3427 19 12.7009 19 13.0748C19 14.7103 18.4091 16.0654 17.4545 17Z"
    fill="#F6F6F9"
  />
  <path
    d="M9 15.2903V14H10.6983C11.1006 15.1613 12.2626 16.0215 13.6034 16.0215C14.2738 16.0215 14.8995 15.8495 15.3464 15.5484L17 16.7957C16.1508 17.5699 14.9888 18 13.6034 18C11.6369 18 9.89385 16.9247 9 15.2903Z"
    fill="#F6F6F9"
  />
  <path
    d="M8.47998 15C8.19998 14.2233 8 13.3981 8 12.4757C8 11.6019 8.15998 10.7767 8.47998 10H10V11.4078C9.84 12.1359 9.84 12.8641 10 13.5437L8.47998 15Z"
    fill="#F6F6F9"
  />
  <path
    d="M10.6983 11L9 9.73913C9.89385 8.04348 11.6369 7 13.6034 7C14.9888 7 16.1508 7.47826 17 8.30435L15.5699 9.69565C15.0335 9.21739 14.3631 8.95652 13.6034 8.95652C12.2626 8.95652 11.1006 9.82609 10.6983 11Z"
    fill="#F6F6F9"
  />
</svg>

<!--ЕРИП-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="61"
  height="22"
  viewBox="0 0 61 22"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M31.0886 7.90659C31.8762 8.84432 32.1534 9.94322 31.92 11.2033H26.0566C26.3191 12.1703 27.1067 12.7418 28.1569 12.7418C29.032 12.7418 29.6446 12.3901 30.0384 11.6868L31.6575 12.4341C31.0011 13.6648 29.6884 14.5 28.0694 14.5C26.8879 14.5 25.9253 14.1044 25.1814 13.3571C24.3938 12.5952 24 11.6429 24 10.5C24 9.35714 24.3792 8.40476 25.1377 7.64286C25.9253 6.88095 26.8879 6.5 28.0256 6.5C29.2946 6.5 30.301 6.98352 31.0886 7.90659ZM26.1003 9.66484H29.9509C29.6446 8.78571 28.9445 8.25824 28.0256 8.25824C27.1067 8.25824 26.3628 8.78571 26.1003 9.66484Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M41.8324 7.6626C42.6108 8.43767 43 9.4065 43 10.5691C43 11.7317 42.6108 12.7005 41.8324 13.4756C41.054 14.2507 40.0811 14.6382 38.9135 14.6382C37.8432 14.6382 36.9513 14.2805 36.2378 13.565V17.5H34V6.67886H36.2378V7.57317C36.9513 6.85772 37.8432 6.5 38.9135 6.5C40.0811 6.5 41.054 6.88753 41.8324 7.6626ZM38.4757 12.7602C39.1243 12.7602 39.6595 12.5515 40.0811 12.1341C40.4703 11.7317 40.7135 11.1951 40.7135 10.5691C40.7135 9.94309 40.4703 9.4065 40.0811 9.00406C39.6595 8.58672 39.1243 8.37805 38.4757 8.37805C37.827 8.37805 37.2919 8.58672 36.8703 9.00406C36.4487 9.42141 36.2378 9.94309 36.2378 10.5691C36.2378 11.1951 36.4324 11.7317 36.8703 12.1341C37.2919 12.5515 37.827 12.7602 38.4757 12.7602Z"
    fill="#7C7E92"
  />
  <path
    d="M46.1272 11.4655L49.9653 6.5H52V14.5H49.9191V9.53448L46.0346 14.5H44V6.5H46.1272V11.4655Z"
    fill="#7C7E92"
  />
  <path
    d="M55.2036 14.5H53V6.5H61V14.5H58.7964V8.33908H55.2036V14.5Z"
    fill="#7C7E92"
  />
  <path d="M5.97631 0.5L11 6.51554L8.48818 9.5L1 0.5H5.97631Z" fill="#7C7E92" />
  <path
    d="M14.6653 4.36046L12.9286 6.5L8 0.5H12.2714C12.6939 0.5 13.1164 0.686047 13.398 1.01163L14.6653 2.59302C15.0878 3.10465 15.1347 3.84884 14.6653 4.36046Z"
    fill="#7C7E92"
  />
  <path
    d="M21.6771 11.414L14.4536 19.9875C14.2144 20.3136 13.7839 20.5 13.3533 20.5H9L19.9071 7.5L21.6771 9.59677C22.1076 10.1093 22.1076 10.9014 21.6771 11.414Z"
    fill="#7C7E92"
  />
  <path
    d="M16.693 7.19367L5.8216 20.5H1L12.5991 6.32785L14.2821 4.23165C14.737 3.73038 14.6915 3.00127 14.2821 2.5L16.693 5.41646C17.1023 5.96329 17.1023 6.6924 16.693 7.19367Z"
    fill="#7C7E92"
  />
</svg>

<!--Apple pay-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="62"
  height="26"
  viewBox="0 0 62 26"
  fill="none"
>
  <path
    d="M12.7804 4.0942C12.0889 4.90485 10.9826 5.54424 9.87617 5.4529C9.73788 4.3568 10.2795 3.1922 10.9134 2.47288C11.6049 1.63939 12.815 1.04567 13.7946 1C13.9098 2.14177 13.4604 3.2607 12.7804 4.0942ZM13.7831 5.66984C12.1811 5.5785 10.8097 6.57184 10.049 6.57184C9.27689 6.57184 8.11289 5.71551 6.84516 5.73834C5.19712 5.76118 3.66433 6.68601 2.82302 8.1589C1.09431 11.1047 2.37356 15.4662 4.04465 17.8639C4.86291 19.0514 5.84251 20.353 7.13328 20.3073C8.35491 20.2617 8.83895 19.5195 10.3141 19.5195C11.8008 19.5195 12.2272 20.3073 13.518 20.2845C14.8549 20.2617 15.6962 19.0971 16.5144 17.9096C17.4479 16.5623 17.8283 15.2493 17.8513 15.1808C17.8283 15.1579 15.2698 14.1874 15.2467 11.2645C15.2237 8.82112 17.2635 7.65652 17.3557 7.58801C16.2033 5.89819 14.4054 5.71551 13.7831 5.66984ZM23.0374 2.35871V20.1589H25.8264V14.0733H29.6872C33.2138 14.0733 35.6916 11.6755 35.6916 8.20457C35.6916 4.73359 33.2599 2.35871 29.7794 2.35871H23.0374ZM25.8264 4.68792H29.0418C31.462 4.68792 32.845 5.9667 32.845 8.21598C32.845 10.4653 31.462 11.7555 29.0303 11.7555H25.8264V4.68792ZM40.7856 20.2959C42.5373 20.2959 44.1623 19.4167 44.8999 18.0238H44.9575V20.1589H47.5391V11.2988C47.5391 8.72978 45.4646 7.07421 42.2723 7.07421C39.3104 7.07421 37.1207 8.75262 37.04 11.059H39.5524C39.7599 9.96289 40.7856 9.24358 42.1916 9.24358C43.8973 9.24358 44.8538 10.0314 44.8538 11.4814V12.4634L41.3733 12.6689C38.1349 12.863 36.3831 14.176 36.3831 16.4596C36.3831 18.7659 38.1925 20.2959 40.7856 20.2959ZM41.5347 18.1836C40.048 18.1836 39.103 17.4757 39.103 16.3911C39.103 15.2721 40.0134 14.6213 41.7537 14.5186L44.8538 14.3245V15.3292C44.8538 16.9962 43.4247 18.1836 41.5347 18.1836ZM50.985 25C53.7048 25 54.9841 23.9724 56.102 20.8554L61 7.24548H58.1649L54.8804 17.7612H54.8227L51.5382 7.24548H48.6224L53.3476 20.2046L53.094 20.9924C52.6676 22.3283 51.9761 22.8421 50.743 22.8421C50.524 22.8421 50.0976 22.8192 49.9247 22.7964V24.9315C50.0861 24.9772 50.7775 25 50.985 25Z"
    fill="#7C7E92"
  />
</svg>

<!--VISA secure-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="38"
  height="40"
  viewBox="0 0 38 40"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 21H37V38H2V21Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.3476 8.15L16.6707 15.85H14.6382L16.315 8.15H18.3476ZM28.8658 14.7H26.2744L25.8679 15.85H23.7337L26.7825 8.7C26.935 8.4 27.2398 8.15 27.6463 8.15H29.374L31 15.85H29.1199L28.8658 14.7ZM28.561 13.15L27.9004 10.25L26.8333 13.15H28.561ZM20.3801 16C19.4654 15.95 18.6016 15.8 18.0935 15.55L18.5 13.9C18.9573 14.1 19.5163 14.4 20.5325 14.35C21.1423 14.35 21.752 14.15 21.752 13.6C21.752 13.3 21.498 13.05 20.7358 12.65C19.9228 12.3 18.9065 11.65 18.9573 10.55C18.9573 9.05 20.3801 8 22.3618 8C23.124 8 23.7846 8.2 24.2419 8.35L23.8862 10C22.9715 9.6 22.2093 9.6 21.9045 9.65C21.2947 9.7 21.0406 10 21.0406 10.3C21.0406 11.2 23.8862 11.3 23.8862 13.35C23.8862 14.95 22.4634 16 20.3801 16ZM15.502 8.15L12.1992 15.85H10.065L8.48984 9.7C8.38822 9.35 8.28659 9.2 7.98171 9.05C7.47358 8.75 6.71138 8.55 6 8.4L6.05082 8.15H9.45529C9.9126 8.15 10.3191 8.45 10.4207 8.95L11.2846 13.4L13.3679 8.15H15.502Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.2353 30.15C10.4706 30.3 10.8824 30.4 11.2941 30.4C11.8235 30.4 12.1765 30.2 12.1765 29.85C12.1765 29.6 11.9412 29.4 11.3529 29.25C10.5882 29 10.1176 28.65 10.1176 28.1C10.1176 27.45 10.7059 27 11.7059 27C12.2353 27 12.5882 27.1 12.8235 27.15L12.5882 27.75C12.4706 27.7 12.1176 27.55 11.7059 27.55C11.1765 27.55 10.9412 27.8 10.9412 28.05C10.9412 28.35 11.2353 28.45 11.8235 28.65C12.5882 28.95 13 29.25 13 29.8C13 30.45 12.4706 31 11.2941 31C10.7647 31 10.2941 30.85 10 30.75L10.2353 30.15Z"
    fill="#FFFFFE"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.8298 29.2051H13.5957V30.3846H15V31H13V27H14.9149V27.5641H13.5957V28.641H14.8298V29.2051Z"
    fill="#FFFFFE"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 30.8C18.8 30.9 18.45 31 17.95 31C16.75 31 16 30.2 16 29.05C16 27.75 16.9 27 18.05 27C18.55 27 18.85 27.1 19 27.15L18.85 27.7C18.7 27.65 18.4 27.55 18.1 27.55C17.3 27.55 16.75 28.05 16.75 29C16.75 29.85 17.25 30.4 18.1 30.4C18.35 30.4 18.7 30.35 18.85 30.25L19 30.8Z"
    fill="#FFFFFE"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19.7377 27V29.2785C19.7377 30.038 20.0328 30.3924 20.5246 30.3924C21.0164 30.3924 21.3115 30.038 21.3115 29.2785V27H22V29.2278C22 30.443 21.4098 31 20.4754 31C19.5902 31 19 30.4937 19 29.2278V27H19.7377Z"
    fill="#FFFFFE"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M23 27.1013C23.3273 27.0506 23.7636 27 24.2 27C24.8 27 25.1818 27.1013 25.5091 27.3038C25.7273 27.5063 25.8364 27.7595 25.8364 28.1139C25.8364 28.6203 25.5091 28.9747 25.0727 29.1266C25.4 29.2278 25.5636 29.481 25.6727 29.8861C25.8364 30.3924 25.9455 30.8481 26 31H25.2364C25.1273 30.8481 25.0727 30.5443 24.9091 30.038C24.8 29.5316 24.6364 29.3797 24.2 29.3797H23.7636V31H23V27.1013ZM23.7636 28.8228H24.2545C24.7455 28.8228 25.0727 28.5696 25.0727 28.1646C25.0727 27.7595 24.7455 27.557 24.2545 27.557C24 27.557 23.8364 27.557 23.7636 27.557V28.8228Z"
    fill="#FFFFFE"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M28.8298 29.2051H27.5957V30.3846H29V31H27V27H28.9149V27.5641H27.5957V28.641H28.8298V29.2051Z"
    fill="#FFFFFE"
  />
</svg>

<!--ID Check-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="43"
  height="40"
  viewBox="0 0 43 40"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.63637 34.9103H1V28.1795H1.63637V34.9103ZM6.28672 28.1795C6.8415 28.1795 7.39628 28.2543 7.95105 28.4038C8.39161 28.5385 8.83217 28.7628 9.17483 29.0769C9.51749 29.391 9.8112 29.75 9.95805 30.1538C10.3497 31.0513 10.3497 32.0385 9.95805 32.9359C9.8112 33.3397 9.51749 33.6987 9.17483 34.0128C8.83217 34.2821 8.39161 34.5513 7.95105 34.6859C7.39628 34.8355 6.8415 34.9103 6.28672 34.9103H3.59441V28.1795H6.28672ZM4.27973 28.7179V34.3718H6.28672C6.77623 34.3718 7.24942 34.297 7.7063 34.1474C8.09791 34.0278 8.44057 33.8483 8.73427 33.609C9.02798 33.3397 9.24009 33.0406 9.37063 32.7115C9.66434 31.9487 9.66434 31.141 9.37063 30.3782C9.22378 30.0641 9.02798 29.75 8.73427 29.4808C8.44057 29.2415 8.09791 29.062 7.7063 28.9423C7.24942 28.7927 6.77623 28.7179 6.28672 28.7179H4.27973ZM17.6923 28.0897C18.0186 28.0897 18.3287 28.1197 18.6224 28.1795C18.9161 28.2393 19.1935 28.344 19.4545 28.4936C19.683 28.5833 19.9114 28.7179 20.1399 28.8974C20.3357 29.0769 20.5152 29.2714 20.6783 29.4808L20.1399 29.7949C20.0093 29.6154 19.8625 29.4658 19.6993 29.3462C19.5035 29.1966 19.3077 29.0769 19.1119 28.9872C18.9161 28.8675 18.6876 28.7927 18.4266 28.7628C18.1981 28.703 17.9534 28.6731 17.6923 28.6731C17.2681 28.6731 16.8601 28.7479 16.4685 28.8974C16.1096 29.0171 15.7832 29.2115 15.4895 29.4808C15.2284 29.7201 15.0163 30.0192 14.8532 30.3782C14.5594 31.141 14.5594 31.9487 14.8532 32.7115C15.0163 33.0705 15.2284 33.3697 15.4895 33.609C15.7832 33.8782 16.1096 34.0727 16.4685 34.1923C16.8601 34.3419 17.2681 34.4167 17.6923 34.4167C17.9534 34.4167 18.1981 34.3868 18.4266 34.3269C18.655 34.297 18.8834 34.2222 19.1119 34.1026C19.3077 34.0128 19.5035 33.8932 19.6993 33.7436C19.8625 33.6239 20.0093 33.4744 20.1399 33.2949L20.6294 33.609C20.4988 33.8184 20.3193 34.0128 20.0909 34.1923C19.8951 34.3718 19.6667 34.5214 19.4056 34.641C19.1445 34.7607 18.8834 34.8504 18.6224 34.9103C17.7902 35.0449 16.958 35 16.2238 34.7308C15.7832 34.5513 15.3916 34.3269 15.049 34.0128C14.69 33.7137 14.4126 33.3547 14.2168 32.9359C13.8741 32.0385 13.8741 31.0513 14.2168 30.1538C14.4126 29.735 14.69 29.3761 15.049 29.0769C15.3916 28.7628 15.7832 28.5385 16.2238 28.359C16.7133 28.1795 17.2028 28.0897 17.6923 28.0897ZM22.6364 31.1859C22.7343 31.0363 22.8485 30.9017 22.979 30.7821C23.1095 30.6624 23.2564 30.5726 23.4196 30.5128C23.5501 30.453 23.697 30.4081 23.8601 30.3782C24.0233 30.3483 24.2028 30.3333 24.3986 30.3333C24.6597 30.3034 24.9371 30.3333 25.2308 30.4231C25.4592 30.5128 25.6713 30.6325 25.8671 30.7821C26.0629 30.9615 26.2098 31.156 26.3077 31.3654C26.4056 31.6047 26.4545 31.859 26.4545 32.1282V34.9103H25.8671V32.3077C25.8671 32.0983 25.8345 31.8889 25.7692 31.6795C25.704 31.5 25.5897 31.3504 25.4266 31.2308C25.296 31.0812 25.1329 30.9765 24.9371 30.9167C24.7086 30.8568 24.4802 30.8269 24.2517 30.8269C24.0559 30.8269 23.8438 30.8718 23.6154 30.9615C23.4196 31.0214 23.2564 31.1111 23.1259 31.2308C22.9627 31.3803 22.8322 31.5449 22.7343 31.7244C22.669 31.9038 22.6364 32.1133 22.6364 32.3526V34.9103H22.0489V28H22.6364V31.1859ZM29.979 30.3333C30.3054 30.3333 30.6154 30.3782 30.9091 30.4679C31.1702 30.5876 31.4149 30.7521 31.6434 30.9615C31.8392 31.1709 32.0023 31.4103 32.1329 31.6795C32.2308 31.9786 32.2797 32.2927 32.2797 32.6218C32.2797 32.6517 32.2797 32.6966 32.2797 32.7564C32.2797 32.7863 32.2797 32.8162 32.2797 32.8462H28.1678C28.1678 33.0855 28.2331 33.3248 28.3636 33.5641C28.4615 33.7436 28.5921 33.9081 28.7552 34.0577C28.951 34.2073 29.1468 34.3269 29.3426 34.4167C29.5711 34.4765 29.8158 34.5064 30.0769 34.5064C30.4033 34.5064 30.7133 34.4466 31.007 34.3269C31.2681 34.2073 31.5128 34.0577 31.7413 33.8782L32.035 34.2372C31.9044 34.3868 31.7412 34.5064 31.5454 34.5962C31.4149 34.6859 31.2517 34.7607 31.0559 34.8205C30.8928 34.8803 30.7296 34.9252 30.5664 34.9551C30.3706 34.985 30.1911 35 30.028 35C29.7016 35 29.3753 34.9402 29.049 34.8205C28.7552 34.7009 28.4942 34.5363 28.2657 34.3269C28.0373 34.1175 27.8578 33.8782 27.7273 33.609C27.5967 33.3098 27.5478 32.9957 27.5804 32.6667C27.5478 32.3376 27.5967 32.0235 27.7273 31.7244C27.8578 31.4252 28.0373 31.1709 28.2657 30.9615C28.4942 30.7521 28.7552 30.5876 29.049 30.4679C29.3427 30.3782 29.6527 30.3333 29.979 30.3333ZM29.979 30.7821C29.7506 30.7821 29.5221 30.8269 29.2937 30.9167C29.0979 31.0064 28.9184 31.1111 28.7552 31.2308C28.5921 31.3803 28.4615 31.5449 28.3636 31.7244C28.2657 31.9338 28.2005 32.1581 28.1678 32.3974H31.6923C31.6597 32.1581 31.6107 31.9338 31.5454 31.7244C31.4475 31.5449 31.317 31.3803 31.1538 31.2308C30.9907 31.0812 30.8112 30.9765 30.6154 30.9167C30.4196 30.8269 30.2075 30.7821 29.979 30.7821ZM35.7063 30.3333C36.0653 30.3333 36.4079 30.3932 36.7343 30.5128C37.0606 30.6325 37.338 30.797 37.5664 31.0064L37.1748 31.4103C36.979 31.2308 36.7506 31.0812 36.4895 30.9615C36.2611 30.8718 36 30.8269 35.7063 30.8269C35.4452 30.8269 35.2005 30.8718 34.972 30.9615C34.7436 31.0513 34.5478 31.1859 34.3846 31.3654C34.1888 31.515 34.042 31.6944 33.9441 31.9038C33.7483 32.4124 33.7483 32.906 33.9441 33.3846C34.042 33.594 34.1725 33.7885 34.3357 33.968C34.5315 34.1175 34.7436 34.2372 34.972 34.3269C35.2005 34.4167 35.4452 34.4615 35.7063 34.4615C36 34.4615 36.2774 34.4167 36.5385 34.3269C36.7669 34.2073 36.979 34.0727 37.1748 33.9231L37.5664 34.2821C37.338 34.5214 37.0606 34.7009 36.7343 34.8205C36.0979 35.0449 35.3636 35.0449 34.7273 34.8205C34.4009 34.7009 34.1235 34.5363 33.8951 34.3269C33.6667 34.1175 33.5035 33.8632 33.4056 33.5641C33.1608 32.9808 33.1608 32.3077 33.4056 31.7244C33.5035 31.4551 33.6667 31.2009 33.8951 30.9615C34.1235 30.7521 34.4009 30.6026 34.7273 30.5128C35.0536 30.3632 35.3799 30.3034 35.7063 30.3333ZM39.3287 32.3077H40.1608L42.2168 30.3782H42.951L40.6014 32.5321L43 34.9103H42.2657L40.1608 32.8013H39.3287V34.9103H38.7413V28H39.3287V32.3077Z"
    fill="#7C7E92"
  />
  <path d="M12 16H7V7H12V16Z" fill="#7C7E92" />
  <path
    d="M8.27586 14.6232C8.66995 15.4333 9.26108 16.148 10 16.7199C9.06404 17.387 7.9803 17.8158 6.8473 17.9588C5.66503 18.1018 4.53202 17.8635 3.49754 17.387C2.41379 16.9105 1.57637 16.148 0.935972 15.195C0.344839 14.242 0 13.0984 0 12.0024C0 10.8587 0.344839 9.76276 0.935972 8.80973C1.57637 7.8567 2.41379 7.09428 3.49754 6.61777C4.53202 6.0936 5.66503 5.903 6.8473 6.04595C7.9803 6.14125 9.06404 6.57012 10 7.28489C9.26108 7.8567 8.66995 8.57147 8.27586 9.38155C7.83251 10.1916 7.63546 11.097 7.63546 12.0024C7.63546 12.9078 7.83251 13.8131 8.27586 14.6232Z"
    fill="#7C7E92"
  />
  <path
    d="M20 12.0024C20 13.0984 19.6552 14.242 19.064 15.195C18.4236 16.148 17.5369 16.9105 16.5025 17.387C15.468 17.8635 14.2857 18.1018 13.1527 17.9588C12.0197 17.8158 10.8867 17.387 10 16.7199C10.7389 16.148 11.3301 15.4333 11.7241 14.6232C12.1182 13.8131 12.3645 12.9078 12.3645 12.0024C12.3645 11.097 12.1182 10.1916 11.7241 9.38155C11.3301 8.57147 10.7389 7.8567 10 7.28489C10.8867 6.57012 12.0197 6.14125 13.1527 6.04595C14.2857 5.903 15.468 6.0936 16.5025 6.61777C17.5369 7.09428 18.4236 7.8567 19.064 8.80973C19.6552 9.76276 20 10.8587 20 12.0024Z"
    fill="#BDBEC8"
  />
</svg>

<!--Белкарт интернет пароль-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="62"
  height="40"
  viewBox="0 0 62 40"
  fill="none"
>
  <path
    d="M13.4402 28.5408C12.7311 27.8273 11.5495 27.8273 10.8404 28.4962L7.20088 31.8852C6.96454 32.1082 6.96452 32.3757 7.05905 32.5987C7.15359 32.777 7.34268 33 7.67355 33H14.0547C14.5746 33 15 32.6433 15 32.1528C15 32.123 15 32.1082 15 32.1082C15 30.7704 14.4328 29.4772 13.4402 28.5408Z"
    fill="#7C7E92"
  />
  <path
    d="M8.99802 26.9028C9.04792 25.9038 8.14955 25.0476 7.10145 25.0476L1.71119 25C1.36182 25 1.11227 25.1903 1.06236 25.4281C0.962545 25.6184 0.962539 25.9514 1.21209 26.1892L5.95353 30.7083C6.30289 31.0889 6.90182 31.0889 7.3011 30.7559C7.3011 30.7242 7.31772 30.7083 7.351 30.7083C8.3991 29.7094 8.99802 28.3299 8.99802 26.9028Z"
    fill="#7C7E92"
  />
  <path
    d="M5.45919 22.4402C6.17266 21.7312 6.17265 20.5495 5.50377 19.8405L2.15938 16.2009C1.89183 15.9645 1.62429 15.9645 1.44592 16.0591C1.22296 16.1536 1.04459 16.3427 1 16.6735V23.1019C1 23.5746 1.35675 24 1.84726 24C1.87699 24 1.89184 24 1.89184 24C3.2296 24 4.52276 23.4328 5.45919 22.4402Z"
    fill="#7C7E92"
  />
  <path
    d="M10.5598 14.4592C11.2688 15.1727 12.4505 15.1727 13.1595 14.5038L16.7991 11.1594C17.0355 10.8918 17.0355 10.6243 16.9409 10.4459C16.8464 10.223 16.6573 10.0446 16.3265 10H9.94535C9.42541 10 9 10.3567 9 10.8472C9 10.877 9 10.8918 9 10.8918C9 12.2296 9.5672 13.5228 10.5598 14.4592Z"
    fill="#7C7E92"
  />
  <path
    d="M16.002 16.099C15.9521 17.097 16.8505 17.9525 17.8986 17.9525L23.2888 18C23.6382 18 23.8877 17.8099 23.9376 17.5723C24.0375 17.3822 24.0375 17.097 23.7879 16.8594L19.0465 12.2495C18.6971 11.9168 18.0982 11.9168 17.6989 12.2495C17.6989 12.2812 17.6823 12.297 17.649 12.297C16.6009 13.295 16.002 14.6733 16.002 16.099Z"
    fill="#7C7E92"
  />
  <path
    d="M19.5408 19.5598C18.8273 20.2688 18.8273 21.4505 19.4962 22.1595L22.8852 25.7991C23.1082 26.0355 23.3757 26.0355 23.5987 25.9409C23.777 25.8937 24 25.6573 24 25.3265V18.9453C24 18.4254 23.6433 18.0473 23.1527 18C23.123 18 23.1082 18 23.1082 18C21.7704 18 20.4772 18.5672 19.5408 19.5598Z"
    fill="#7C7E92"
  />
  <path
    d="M17.9028 25.002C16.9038 24.9521 16.0476 25.8505 16.0476 26.8986L16 32.2888C16 32.6382 16.1903 32.8877 16.4281 32.9376C16.6184 33.0375 16.9514 33.0375 17.1892 32.7879L21.7083 28.0465C22.0889 27.6971 22.0889 27.0982 21.7559 26.6989C21.7242 26.6989 21.7083 26.6823 21.7083 26.649C20.7094 25.6009 19.3299 25.002 17.9028 25.002Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 14.552V15.512C9 16.328 8.37501 17 7.61608 17H7.12501C7.03573 17 6.99107 16.952 6.94643 16.856L6.76785 15.368C6.76785 15.304 6.78274 15.272 6.81251 15.272C6.94644 15.128 7.08035 14.936 7.08035 14.696C7.08035 14.312 6.76785 14.024 6.41071 14.072C6.14285 14.12 5.91965 14.36 5.91965 14.648C5.875 14.888 6.00892 15.128 6.18749 15.272C6.21726 15.272 6.23215 15.304 6.23215 15.368L6.00894 16.856C6.00894 16.952 5.91964 17 5.83035 17H5.38392C4.62499 17 4 16.328 4 15.512V14.552C4 13.928 4.35714 13.352 4.89286 13.16V12.728C4.89286 11.768 5.60714 11 6.5 11C7.39286 11.048 8.10714 11.816 8.10714 12.776V13.16C8.59821 13.352 8.95536 13.88 9 14.552ZM7.75 12.776C7.75 12.008 7.21429 11.384 6.5 11.384C5.83035 11.384 5.25 12.008 5.25 12.728V13.064C5.27976 13.064 5.3244 13.064 5.38392 13.064C5.42857 13.064 7.70536 13.064 7.75 13.064V12.776Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M35 15.271C35 16.2991 34.1688 17 33.026 17C31.9351 17 31 16.3458 31 15.1308V14.4766C31 13.3084 31.6753 12.4206 32.8701 12.1869L34.6364 12V12.6542L33.026 12.8411C32.2987 12.9813 31.8831 13.4019 31.8312 14.243C32.0909 13.7757 32.6624 13.6355 33.1299 13.6355C34.2208 13.6355 35 14.2897 35 15.271ZM34.1688 15.271C34.1688 14.6636 33.7013 14.243 33.026 14.243C32.3507 14.243 31.8312 14.6636 31.8312 15.271C31.8312 15.9252 32.3507 16.3458 33.026 16.3458C33.7013 16.3458 34.1688 15.9252 34.1688 15.271Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M35.8649 16.3158C35.8649 16.4211 36.0811 16.7368 36.3514 17.1053C36.3153 17.0702 36.2613 17.0351 36.1892 17C36.2973 17.1579 36.4595 17.3158 36.6216 17.4737C36.7838 17.7368 36.946 17.9474 37 18C35.8649 18 35 17.2105 35 16C35 14.8947 35.8108 14 37 14C38.0811 14 38.8919 14.6842 39 15.9474C39 16.0526 39 16.1754 39 16.3158H35.8649ZM36.6216 17.4737C36.5496 17.3684 36.4595 17.2456 36.3514 17.1053C36.5676 17.2632 36.7838 17.3158 37.0541 17.3158C37.5405 17.3158 37.8649 17.1053 38.027 16.8421H38.8919C38.6757 17.5263 37.973 18 37.0541 18C37.0541 18 36.8378 17.7368 36.6216 17.4737ZM36.027 16.8421C36.063 16.9123 36.1171 16.9649 36.1892 17C36.1351 16.8947 36.027 16.8421 36.027 16.8421ZM38.1351 15.6316C38.1351 15.1053 37.6487 14.6842 37 14.6842C36.4054 14.6842 35.9189 15.1053 35.8649 15.6316H38.1351Z"
    fill="#7C7E92"
  />
  <path
    d="M39.0435 17.2296C39.2609 17.2296 39.5217 17.0654 39.5217 16.4085V14H42V17.9959H41.3044V14.7663H40.2174V16.4085C40.2174 17.558 39.6956 18.0506 39 17.9959L39.0435 17.2296Z"
    fill="#7C7E92"
  />
  <path
    d="M44.3846 15.863L46 14H45.1231L44.2461 15.0411L43.7385 15.589V14H43.0461H43V18H43.0461H43.7385V16.137L44.2461 16.7945L45.1231 18H46L44.3846 15.863Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M50 14.1053V17.9474H49.15V17.3684C48.85 17.7895 48.3 18 47.85 18C47.85 18 47.8333 18 47.8 18C47.25 18 46.85 17.8421 46.55 17.4737C46.5167 17.4737 46.5 17.4561 46.5 17.4211C46.4667 17.4211 46.45 17.4211 46.45 17.4211C46.15 17.0702 46 16.5965 46 16C46 15.4737 46.15 15 46.45 14.6316C46.45 14.6316 46.4667 14.614 46.5 14.5789C46.5 14.5789 46.5167 14.5614 46.55 14.5263C46.85 14.2105 47.25 14 47.8 14C47.8333 14 47.85 14 47.85 14C48.3 14 48.85 14.2632 49.15 14.6842L49.25 14.1053H50ZM49.2 16C49.2 15.3158 48.7 14.7895 48.05 14.7895C47.35 14.7895 46.85 15.3158 46.85 16C46.85 16.7368 47.35 17.2632 48.05 17.2632C48.7 17.2632 49.2 16.7368 49.2 16Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M51.75 14.0926L51.8 14.6019C52.15 14.2315 52.65 14 53.15 14C53.15 14 53.1667 14 53.2 14C53.75 14 54.15 14.1852 54.45 14.463C54.4833 14.4938 54.5 14.5093 54.5 14.5093C54.5 14.5401 54.5167 14.5556 54.55 14.5556C54.85 14.8796 55 15.2963 55 15.7593C55 16.284 54.85 16.7006 54.55 17.0093C54.5167 17.0093 54.5 17.0093 54.5 17.0093C54.5 17.0401 54.4833 17.0556 54.45 17.0556C54.15 17.3333 53.75 17.5185 53.2 17.5185C53.1667 17.5185 53.15 17.5185 53.15 17.5185C52.65 17.5185 52.15 17.3333 51.8 16.963V19H51V14.0926H51.75ZM53.05 16.8704C53.75 16.8704 54.2 16.4074 54.2 15.7593C54.2 15.1574 53.75 14.6944 53.05 14.6944C52.35 14.6944 51.85 15.1574 51.85 15.7593C51.85 16.4074 52.35 16.8704 53.05 16.8704Z"
    fill="#7C7E92"
  />
  <path
    d="M61 15.5467V18H60.1429V15.76C60.1429 15.0667 59.7679 14.7467 59.2857 14.7467C58.8036 14.7467 58.4286 15.12 58.4286 15.76V18H57.5714V15.76C57.5714 15.0667 57.1964 14.7467 56.7143 14.7467C56.2321 14.7467 55.8572 15.12 55.8572 15.76V18H55V14.1067H55.75L55.8572 14.64C56.0714 14.2667 56.4464 14 57.0357 14C57.5714 14 58 14.2667 58.2143 14.64C58.4821 14.2667 58.9107 14 59.5536 14C60.4107 14 61 14.5867 61 15.5467Z"
    fill="#7C7E92"
  />
  <path
    d="M33.4179 20H34V23H33.3284V21L31.5821 23H31V20H31.6716V22L33.4179 20Z"
    fill="#7C7E92"
  />
  <path
    d="M37.3437 20H38V23H37.3437V21.9167H35.6563V23H35V20H35.6563V21.2917H37.3437V20Z"
    fill="#7C7E92"
  />
  <path
    d="M59.1311 23V20.5417H58V20H61V20.5417H59.8689V23H59.1311Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M42.8767 21.7027C42.9315 22.1486 43.4247 22.473 44.0822 22.473C44.5205 22.473 44.8493 22.3514 45.0137 22.1486H45.8904C45.6165 22.6351 44.9041 23 44.0274 23C42.8767 23 42 22.3919 42 21.5C42 20.6486 42.8219 20 43.9726 20C45.0685 20 45.8904 20.527 46 21.4595C46 21.5405 46 21.6216 46 21.7027H42.8767ZM45.1233 21.2162C45.0685 20.8108 44.6302 20.527 43.9726 20.527C43.3699 20.527 42.8767 20.8108 42.8767 21.2162H45.1233Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M54.8767 21.7027C54.9315 22.1486 55.4247 22.473 56.0822 22.473C56.5206 22.473 56.8493 22.3514 57.0685 22.1486H57.8904C57.6712 22.6351 56.9589 23 56.0822 23C54.8767 23 54 22.3919 54 21.5C54 20.6486 54.8767 20 56.0274 20C57.1233 20 57.8904 20.527 58 21.4595C58 21.5405 58 21.6216 58 21.7027H54.8767ZM57.1233 21.2162C57.1233 20.8108 56.6849 20.527 56.0274 20.527C55.4247 20.527 54.9315 20.8108 54.8767 21.2162H57.1233Z"
    fill="#7C7E92"
  />
  <path
    d="M52.3437 20H53V23H52.3437V21.9167H50.6563V23H50V20H50.6563V21.2917H52.3437V20Z"
    fill="#7C7E92"
  />
  <path
    d="M40.1311 23V20.5417H39V20H42V20.5417H40.918V23H40.1311Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M46.7179 20.0476L46.8205 20.5714C47.1282 20.1905 47.6923 20 48.1538 20C48.1538 20 48.1709 20 48.2051 20C48.7692 20 49.1795 20.1905 49.4872 20.4762C49.4872 20.4762 49.5043 20.4921 49.5384 20.5238C49.8461 20.8571 50 21.2857 50 21.7619C50 22.2857 49.8461 22.7143 49.5384 23C49.5384 23 49.5384 23.0159 49.5384 23.0476C49.5043 23.0476 49.4872 23.0635 49.4872 23.0952C49.1795 23.381 48.7179 23.5238 48.2051 23.5238C48.1709 23.5238 48.1538 23.5238 48.1538 23.5238C47.6923 23.5238 47.1282 23.3333 46.8205 22.9524V25H46V20.0476H46.7179ZM48 22.8571C48.7179 22.8571 49.1795 22.4286 49.1795 21.7619C49.1795 21.1429 48.7179 20.6667 48 20.6667C47.3333 20.6667 46.8205 21.1429 46.8205 21.7619C46.8205 22.381 47.3333 22.8571 48 22.8571Z"
    fill="#7C7E92"
  />
  <path d="M34 26V29H33.2727V26.5417H31.7727V29H31V26H34Z" fill="#7C7E92" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M53.5263 26.9583C54.4211 26.9583 55 27.3333 55 27.9583C55 28.625 54.4211 29 53.5263 29H52V26H52.7369V26.9583H53.5263ZM53.4211 28.4167C53.8947 28.4167 54.2631 28.2917 54.2631 27.9583C54.2631 27.6667 53.8947 27.5 53.4211 27.5H52.6842V28.4167H53.4211Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M38.282 26.1081H39V29.9459H38.1795V29.3513C37.8718 29.7838 37.359 30 36.8462 30C36.812 30 36.7949 30 36.7949 30C36.282 30 35.8205 29.7838 35.5641 29.4595C35.5299 29.4595 35.5128 29.4595 35.5128 29.4595C35.4786 29.4234 35.4615 29.4054 35.4615 29.4054C35.1539 29.027 35 28.5946 35 28C35 27.4595 35.1539 26.973 35.4615 26.5946C35.4615 26.5946 35.4786 26.5946 35.5128 26.5946C35.5128 26.5946 35.5299 26.5766 35.5641 26.5405C35.8718 26.2162 36.282 26 36.7949 26C36.7949 26 36.812 26 36.8462 26C37.359 26 37.8718 26.2703 38.1795 26.6486L38.282 26.1081ZM38.1795 28C38.1795 27.2973 37.7179 26.8108 37 26.8108C36.3333 26.8108 35.8205 27.2973 35.8205 28C35.8205 28.7568 36.3333 29.2432 37 29.2432C37.6667 29.2432 38.1795 28.7027 38.1795 28Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M40.718 26.0952L40.8205 26.5714C41.1282 26.2381 41.6923 26 42.1539 26C42.188 26 42.2051 26 42.2051 26C42.7179 26 43.1795 26.1905 43.4872 26.4762C43.4872 26.4762 43.4872 26.4921 43.4872 26.5238C43.5214 26.5238 43.5385 26.5397 43.5385 26.5714C43.8462 26.8571 44 27.2857 44 27.7619V27.8095C44 28.2857 43.8462 28.7143 43.5385 29C43.5385 29.0317 43.5214 29.0476 43.4872 29.0476C43.4872 29.0476 43.4872 29.0635 43.4872 29.0952C43.1795 29.381 42.7179 29.5714 42.2051 29.5714C42.2051 29.5714 42.188 29.5714 42.1539 29.5714C41.6923 29.5714 41.1282 29.3333 40.8205 29V31H40V26.0952H40.718ZM42 28.8571C42.6667 28.8571 43.1795 28.4286 43.1795 27.7619C43.1795 27.1429 42.6667 26.7143 42 26.7143C41.2821 26.7143 40.8205 27.1429 40.8205 27.7619C40.8205 28.381 41.3333 28.8571 42 28.8571Z"
    fill="#7C7E92"
  />
  <path
    d="M48.0435 28.4247C48.2609 28.3836 48.5217 28.2603 48.5217 27.8082V26H51V29H50.3044V26.5753H49.1739V27.8082C49.1739 28.6301 48.6957 29 48 29L48.0435 28.4247Z"
    fill="#7C7E92"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M48 28C48 29.1892 47.1579 30 46 30C44.8421 30 44 29.1351 44 28C44 26.8649 44.8421 26 46 26C47.1579 26 48 26.8649 48 28ZM47.1579 28C47.1579 27.2973 46.6842 26.7568 46 26.7568C45.3158 26.7568 44.7895 27.2973 44.7895 28C44.7895 28.7027 45.3158 29.2432 46 29.2432C46.6842 29.2432 47.1579 28.7027 47.1579 28Z"
    fill="#7C7E92"
  />
</svg>

<!--Альфабанк-->
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="27"
  viewBox="0 0 16 27"
  fill="none"
>
  <g clip-path="url(#clip0_21703_5504)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 22.9445H16V26.5H0V22.9445ZM4.75943 14.553H11.0703L12.1354 18.128H15.6349L10.912 3.1C10.4554 1.657 9.92629 0.5 8.11886 0.5C6.31086 0.5 5.75714 1.6375 5.28286 3.1L0.340571 18.1215H3.62114L4.75943 14.553ZM7.96 4.4H8.03886L10.1629 11.55H5.72L7.96 4.4Z"
      fill="#7C7E92"
    />
  </g>
  <defs>
    <clipPath id="clip0_21703_5504">
      <rect width="16" height="26" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
